export const numberToCurrency = (price: string) => Number.parseFloat(price).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })
